const EXTRANET_GROUPS = [
  'extranet_CoDi',
  'extranet_GeOp',
  'extranet_Supervisor',
  'extranet_Cliente'
]

const SUPPLIERS_GROUPS = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras',
  'DesProveedores',
  'CoorProveeduria',
  'GeLogistica',
  'Proveeduría'
]

const SUPPLIER_GROUPS_LOW_TIER = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras'
]

const COOR_ACO_GROUP = 'CoorCostos'
const JR_ACO_GROUP = 'ACoJr'
const SR_ACO_GROUP = 'ACoSr'

export { EXTRANET_GROUPS, SUPPLIERS_GROUPS, SUPPLIER_GROUPS_LOW_TIER, COOR_ACO_GROUP, JR_ACO_GROUP, SR_ACO_GROUP }
